/**
 * Theme scripts
 * @since 1.1
 */
document.addEventListener('load', function() {
    // Smooth scroll to anchor on load
    if (window.location.hash) {
        const tgt_id   = window.location.hash.substring(1);
        const tgt_elem = document.getElementById(tgt_id);

        if (tgt_elem) {
            // Get target margin
            let tgt_elem_margin = window.getComputedStyle(tgt_elem).scrollMarginBlockStart;

            tgt_elem_margin = (tgt_elem_margin) ? parseInt(tgt_elem_margin) : 0;

            // Scroll to target
            window.scrollTo({
                top: tgt_elem.offsetTop - tgt_elem_margin,
                behavior: 'smooth'
            });
        }
    }
});
